import React, { RefObject, useEffect, useState } from 'react';
import classNames from 'classnames';
import Flicking, { ChangedEvent } from '@egjs/react-flicking';
import { EVENTS } from '@egjs/flicking';
import ArrowRightLight from '@/assets/arrowRightLight.svg';

type CarouselPortraitProgressModel = {
  carousel: RefObject<Flicking | null>;
} & React.HTMLAttributes<HTMLElement>;
const CarouselPortraitProgress = ({ carousel, className, ...props }: CarouselPortraitProgressModel) => {
  const [progressStyle, setProgressStyle] = useState<{ width: string; left: string }>({ width: '0%', left: '0%' });

  useEffect(() => {
    const _carousel = carousel.current;
    const onCarouselChanged = (e?: ChangedEvent) => {
      if (_carousel) {
        const totalSlides = _carousel.camera.anchorPoints.length;
        const currentSlide = e?.index || 0;
        if (totalSlides > 0 && currentSlide <= totalSlides) {
          const slidesToShow = 1;
          const unit = 100 / totalSlides;
          const left = unit * currentSlide;
          const width = unit * slidesToShow;

          setProgressStyle({
            width: `${width}%`,
            left: `${left < 0 || left + width > 101 ? 0 : left}%`,
          });
        }
      }
    };

    const onReady = () => {
      setTimeout(() => {
        onCarouselChanged();
      }, 500);
    };

    if (_carousel) {
      _carousel.on(EVENTS.CHANGED, onCarouselChanged);
      _carousel.on(EVENTS.READY, onReady);
    }
    return () => {
      if (_carousel) {
        _carousel.off(EVENTS.READY);
        _carousel.off(EVENTS.CHANGED);
      }
    };
  }, [carousel]);

  const onPrevClick = () => {
    if (carousel.current && !carousel.current.animating) {
      carousel.current.prev();
    }
  };
  const onNextClick = () => {
    if (carousel.current && !carousel.current.animating) {
      carousel.current.next();
    }
  };

  return (
    <div className={classNames(className, 'carousel-portrait-progress flex items-center gap-8')} {...props}>
      <button
        onClick={onPrevClick}
        className={classNames(
          'fill-from-bg transition-all disabled:opacity-20',
          'cursor-pointer opacity-60 hover:opacity-100',
        )}
      >
        <ArrowRightLight className="h-8 w-8 rotate-180" />
      </button>
      <div className="progress-bar bg-from-bg/20 relative h-[3px] w-full">
        <div
          className="progress bg-from-bg absolute h-[3px] transition-all duration-300 ease-in-out"
          style={{
            ...progressStyle,
          }}
        ></div>
      </div>
      <button
        onClick={onNextClick}
        className={classNames(
          'fill-from-bg transition-all disabled:opacity-20',
          'cursor-pointer opacity-60 hover:opacity-100',
        )}
      >
        <ArrowRightLight className="h-8 w-8" />
      </button>
    </div>
  );
};

export default CarouselPortraitProgress;
